import { PageTemplate } from '@ui/templates';
import { StorageControls } from '@widgets/storage-controls';
import { StorageViewer } from '@widgets/storage-viewer';
import { useGate } from '@lib/state-engine';
import { PageGate } from './model';
import styles from './styles.module.css';

export const StoragePage = () => {
  useGate(PageGate);
  return (
    <PageTemplate header="Склады">
      <StorageControls />
      <StorageViewer />
    </PageTemplate>
  );
};
